import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./InputItem.module.css";

/**
 * Interactive component.
 * Custom input text that takes a label prop.
 */

export function InputItem({
  label,
  value,
  setValue,
  placeholder,
  errors,
  isPhoneNumber,
}) {
  const [isValid, setIsValid] = useState(false);
  const [error, setIsError] = useState(false);

  const [isFocused, setIsFocused] = useState(false);

  const handleInputChange = (e) => {
    let inputValue = e.target.value;

    // console.log("input", inputValue);

    if (isPhoneNumber) {
      // Remove non-numeric characters and limit to 10 digits
      let phoneInput = inputValue.replace(/\D/g, "").slice(0, 10);

      // Validate phone number
      if (phoneInput.length === 10) {
        setIsValid(true);
      } else {
        setIsValid(false);
      }

      // Format phone number
      inputValue = formatPhoneNumber(phoneInput);
    } else {
      setIsValid(!!inputValue);
    }

    setValue(inputValue);
  };

  const handleInput = (e) => {
    handleInputChange(e);
    setIsValid(e.target.value.length > 0);
  };

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = (e) => {
    setIsFocused(false);
    handleInputChange(e);
  };

  const formatPhoneNumber = (input) => {
    const cleaned = input.replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return cleaned;
  };

  return (
    <div className={styles.container}>
      <label
        htmlFor={
          typeof label === "string"
            ? label.toLowerCase().split(" ").join("-")
            : label
        }
        className={styles.label}
      >
        {label}
      </label>
      <input
        id={label}
        className={`${styles.input} ${errors ? styles.inputError : ""} ${
          // isValid ? styles.inputValid : ""
          isValid && isFocused ? styles.inputValid : ""
        }`}
        type="text"
        name={
          typeof label === "string"
            ? label.toLowerCase().split(" ").join("-")
            : label
        }
        value={value}
        onChange={handleInputChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onInput={handleInput}
        placeholder={placeholder}
      />
      <div className={styles.errorContainer}>
        {errors && !isFocused && <span className={styles.error}>{errors}</span>}
      </div>
    </div>
  );
}

InputItem.propTypes = {
  /**
   * Displays label text.
   */
  label: PropTypes.string,
  /**
   * Value of the text box.
   */
  value: PropTypes.string,
  /**
   * Function that changes the input box value.
   */
  setValue: PropTypes.func,
};
